export default function getArticleDistributeState({
	publisher,
	formState,
	isSubmitted,
	filteredChannels,
	articlesWithError,
}) {
	if (!publisher) {
		return "noPublisher";
	}

	if (filteredChannels?.length === 0) {
		return "unavailable";
	}

	if (formState.isSubmitting) {
		return "submitting";
	}

	if (isSubmitted) {
		return articlesWithError.length === 0 ? "completed" : "failed";
	}

	return "initial";
}
